/**
 * @packageDocumentation
 * @module dom/attribute
 */

export type TAttr = string | number | boolean | null;

export interface SetAttr {
  /**
   * set an attribute on an element when appropriate, for performance
   *
   * @param el a html element to set attributes
   * @param name to write or delete from an attribute
   * @param value if `false`, `undefined`, `null` or `''` we remove the attribute
   * @return the element provided, but it will not have the attributes assigned immediately because of performance
   */
  (el: Element, name: string, value: TAttr): Element;
}

/**
 * { @link SetAttr }
 */
export default (el: Element, name: string, value: TAttr): Element => {
  // null, undefined, false, empty-string are invalid and result in removing the attribute
  const isValidAttribute = !(!value && value !== 0);
  const attrValue = typeof value === 'boolean' ? name : `${value}`;
  if (isValidAttribute) {
    el.setAttribute(name, attrValue);
  } else {
    el.removeAttribute(name);
  }

  return el;
};
